import { RootState } from "@app/store/rootReducer";

export const getLegendsState = (state: RootState) => state.mapLegends;
